import { CSSProperties } from 'react'

const styles: {
  container: CSSProperties
  backdrop: CSSProperties
  panel: CSSProperties
  header: CSSProperties
  headerTitle: CSSProperties
  headerActions: CSSProperties
  closeIcon: CSSProperties
  list: CSSProperties
  footer: CSSProperties
  emptyText: CSSProperties
  checkbox: CSSProperties
  categoryCheckbox: CSSProperties
  categoryMembers: CSSProperties
  chevron: CSSProperties
} = {
  container: {
    display: 'flex',
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    zIndex: 9999,
  },
  backdrop: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: 'black',
    opacity: 0.6,
    zIndex: 1,
  },
  panel: {
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    width: 320,
    maxHeight: '70%',
    backgroundColor: '#3a3a3a',
    borderRadius: 12,
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.5)',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 16px',
    borderBottom: '1px solid #4d4d4d',
  },
  headerTitle: {
    fontSize: 16,
    fontWeight: 600,
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  closeIcon: {
    fontSize: 18,
    color: '#aaaaaa',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    padding: 8,
  },
  footer: {
    padding: 8,
    borderTop: '1px solid #4d4d4d',
  },
  emptyText: {
    color: '#aaaaaa',
    padding: '16px 8px',
    textAlign: 'center',
  },
  checkbox: {
    fontSize: 16,
    width: 18,
    flexShrink: 0,
  },
  categoryCheckbox: {
    padding: 2,
  },
  categoryMembers: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 20,
    borderLeft: '1px solid #4d4d4d',
  },
  chevron: {
    fontSize: 14,
    color: '#aaaaaa',
  },
}

export default styles
